import { render } from "./score.vue?vue&type=template&id=2c702ae4&scoped=true&ts=true"
import script from "./score.vue?vue&type=script&lang=tsx"
export * from "./score.vue?vue&type=script&lang=tsx"

import "./score.vue?vue&type=style&index=0&id=2c702ae4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c702ae4"]])

export default __exports__